"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzFrame = exports.SzCarousel = void 0;

var react_1 = __importDefault(require("react"));

var react_elastic_carousel_1 = __importDefault(require("react-elastic-carousel"));

var __1 = require("../../");

var classnames_1 = __importDefault(require("classnames"));

require("./SzCarousel.scss");

exports.SzCarousel = function (_a) {
  var children = _a.children,
      className = _a.className,
      carouselHeight = _a.carouselHeight,
      props = __rest(_a, ["children", "className", "carouselHeight"]);

  var defaultProps = {
    enableAutoPlay: true,
    autoPlaySpeed: 5000,
    transitionMs: 500,
    itemPadding: [0, 10]
  };

  var renderArrow = function renderArrow(_a) {
    var type = _a.type,
        onClick = _a.onClick;
    var pointerLeft = 'navigation-left-circle-1_1';
    var pointerRight = 'navigation-right-circle-1';
    var pointer = type === 'PREV' ? pointerLeft : pointerRight;
    return react_1.default.createElement(__1.SzButton, {
      onClick: onClick,
      variant: "tertiary",
      icon: pointer,
      className: "arrows"
    });
  };

  var classes = classnames_1.default('sz-carousel', className);
  return react_1.default.createElement(react_elastic_carousel_1.default, __assign({}, defaultProps, props, {
    className: classes,
    renderArrow: renderArrow
  }), children);
};

exports.SzFrame = function (_a) {
  var className = _a.className,
      children = _a.children,
      carouselHeight = _a.carouselHeight,
      alt = _a.alt,
      props = __rest(_a, ["className", "children", "carouselHeight", "alt"]);

  var style = {
    maxHeight: carouselHeight ? carouselHeight + "px" : ''
  };
  var classes = classnames_1.default('position-absolute sz-carousel__full-content', className);

  var renderImage = function renderImage(alt, props) {
    var src = props.src,
        defaultSrc = props.defaultSrc;

    if (!('string' === typeof src)) {
      var sources = src.map(function (item, key) {
        return react_1.default.createElement("source", __assign({
          key: key,
          className: "sz-carousel__img w-100"
        }, item));
      });
      return react_1.default.createElement("picture", null, sources, react_1.default.createElement("img", __assign({
        alt: alt,
        src: defaultSrc
      }, props)));
    }

    return react_1.default.createElement("img", __assign({
      className: "sz-carousel__img w-100",
      alt: alt
    }, props));
  };

  return children ? react_1.default.createElement("div", {
    className: "sz-carousel__full position-relative w-100 ",
    style: style
  }, renderImage(alt, props), react_1.default.createElement("div", {
    className: classes
  }, children)) : renderImage(alt, props);
};

exports.SzCarousel.SzFrame = exports.SzFrame;
exports.default = exports.SzCarousel;